import styled from 'styled-components'
import { Carousel } from 'antd'
import { greys } from 'assets/themes/theme-default'

const AntCarouselStyled = styled(Carousel)`
  .slick-dots li button {
    margin: 20px 0 0 0;
    height: 5px;
    background: ${greys.dark2};
  }
  .slick-dots li.slick-active button {
    background: ${props => props.theme.colors.color1.bg};
  }

  .slick-arrow {
    width: 60px;
    height: 60px;
    border-radius: 30px;
    background: ${greys.light4};
    color: ${props => props.theme.colors.color1.bg};
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
    :hover,
    :active,
    :focus {
      opacity: 0.5;
      background: ${greys.light4};
      color: ${props => props.theme.colors.color1.bg};
    }
    &.slick-disabled {
      opacity: 0.5;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0);
      :hover {
        cursor: not-allowed;
      }
    }
  }

  .slick-prev {
    left: -69px;
    z-index: 1;
    :before {
      content: '<';
      position: absolute;
      margin-left: -11px;
      width: 30px;
      height: 30px;
      left: 50%;
      top: 50%;
      margin-left: -20px;
      font-size: 40px;
      font-family: 'Material Design Icons';
      content: '\f141';
    }
  }
  .slick-next {
    right: -69px;
    z-index: 1;
    :before {
      content: '>';
      position: absolute;
      margin-left: -18px;
      width: 30px;
      height: 30px;
      font-size: 40px;
      font-family: 'Material Design Icons';
      content: '\f142';
    }
  }
`

export default AntCarouselStyled
